
import { Student } from "@/services/db/types";

/**
 * Find the appropriate program for certificate generation
 */
export const findProgramForCertificate = (student: Student, programId?: string) => {
  if (programId) {
    return student.programs?.find(p => p.title === programId);
  }
  return student.programs?.find(p => p.feeStatus === 'paid') || student.programs?.[0];
};

/**
 * Get full student name including surname
 */
export const getStudentFullName = (student: Student): string => {
  return student.surname ? `${student.name} ${student.surname}` : student.name;
};

/**
 * Validate student data for certificate generation
 */
export const validateStudentForCertificate = (student: Student, programId?: string): void => {
  if (!student) {
    throw new Error('Student data is required for certificate generation');
  }

  const selectedProgram = findProgramForCertificate(student, programId);
  if (!selectedProgram) {
    throw new Error('No eligible program found for certificate');
  }

  if (!student.name) {
    throw new Error('Student name is required for certificate generation');
  }
};
